
import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {readForm, readFormValues, readMenuForm} from '@/store/main/getters';
import {dispatchGetForm, dispatchGetFormValuesByID} from '@/store/main/actions';
import DisplayValue from '@/components/DisplayValue.vue';
import PdfPreviewDialog from '@/components/dialogs/PdfPreviewDialog.vue';

@Component({
  components: {DisplayValue, PdfPreviewDialog},
})
export default class RendererPreviewContent extends Vue {

  @Prop(Number) public formValueId;
  @Prop(Number) public formId;
  @Prop(Object) public formValue;
  @Prop({type: String, default: 'report'}) public mode!: string;

  public async mounted() {

    if (this.formValueId && !this.storeFormValues) {
      await dispatchGetFormValuesByID(this.$store, this.formValueId);
    }

    if (!this.form && this.resolvedFormId) {
      await dispatchGetForm(this.$store, this.resolvedFormId);
    }
  }

  private get storeFormValues() {
    if (!this.formValueId) {
      return null;
    }
    return readFormValues(this.$store)(+this.formValueId);
  }

  private get resolvedFormValues() {
    return this.formValue || this.storeFormValues;
  }

  private get resolvedFormValueId() {
    return this.resolvedFormValues?.id || this.formValueId;
  }

  private get resolvedFormId() {
    return this.formId || this.resolvedFormValues?.form_id;
  }

  private get isDatagridMode() {
    return this.mode === 'datagrid';
  }

  private get form() {
    if (!this.resolvedFormId) {
      return null;
    }
    return readForm(this.$store)(+this.resolvedFormId) || readMenuForm(this.$store)(+this.resolvedFormId);
  }

  private get formData() {
    return this.form?.form_setting?.form_data;
  }

  private get currentValues() {
    return this.resolvedFormValues?.form_values || this.resolvedFormValues;
  }

  private showSection(section) {
    return this.isDatagridMode || !section.hideOnReport;
  }

  private showControl(control) {
    if (this.isEmptyBlockControl(control)) {
      return false;
    }
    return this.isDatagridMode || !control.hideOnReport;
  }

  private getControlValue(key) {
    const control = this.formData?.controls?.[key];
    const fieldName = control?.name ? control.name : control?.uniqueId;
    return fieldName ? this.currentValues?.[fieldName] : null;
  }

  private getItemText(key) {
    try {
      const controls = this.formData?.controls;
      const control = controls?.[key];
      const value = this.getControlValue(key);

      if (this.isEmptyValue(value)) {
        return null;
      } else if (control?.type === 'radio') {
        return value;
      } else if (control?.type === 'checkbox') {
        return value;
      } else if (control?.type === 'fileUploadControl') {
        return null;
      } else if (control?.type === 'datePickerControl') {
        if (value.length !== 10) {
          return null;
        }
        if (value.includes('/')) {
          return value;
        }

        const [year, month, day] = value.split('-');
        return `${day}/${month}/${year}`;
      }

      return value;

    } catch (e) {
      console.error(e);
      return null;
    }
  }

  private isEmptyValue(value) {
    return value === null || value === undefined || value === '' || (Array.isArray(value) && value.length === 0);
  }

  private isEmptyBlockControl(control) {
    const values = [control?.type, control?.label, control?.name, control?.uniqueId]
        .filter(Boolean)
        .map((value) => String(value).toLowerCase().replace(/[\s_-]/g, ''));
    return values.includes('emptyblock') || values.includes('emptyblockcontrol');
  }

  private getFormFileID(item) {
    return item?.form_files_id;
  }

  private isFormFileValue(item) {
    return item && typeof item === 'object' && (item.type || item.name || item.upload_status || item.form_files_id);
  }

  private formatFormFile(item) {
    if (!item) {
      return null;
    }
    if (item.upload_status === 'pending') {
      return `${item.name || 'Arquivo'} (upload pendente)`;
    }
    if (item.form_files_id) {
      return item.name || 'Arquivo anexado';
    }
    return `${item.name || 'Arquivo'} (indisponível)`;
  }

}
